import { Observable } from "rxjs";
import { ICrossSell } from "src/app/domain/interfaces/crossell/interface-cross-sell";
import { SourceOfResource } from "../../resources/source-of-resource-enum";

export abstract class CrossSellsGateway {
  abstract getCrossSellsData(): Observable<Array<ICrossSell>>;
  abstract initCrossSellsData(sourceOfResource: SourceOfResource): any;
}